import { render, staticRenderFns } from "./MoveLevels.vue?vue&type=template&id=cb915e80&"
import script from "./MoveLevels.vue?vue&type=script&lang=js&"
export * from "./MoveLevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports